import axios from 'axios';
import { createStore } from 'vuex'

export default createStore({
  state: {
    comics: [],
  },
  mutations: {
    FETCH_COMICS(state, comics) {
      return state.comics = comics;
    },
  },
  actions: {
    async fetchDownloads({commit}) {
      try {
        const res = await axios.get('/downloads.json');
        commit('FETCH_COMICS', res.data['comics']);
      } catch (err) {
        console.log(err);
      }
    },
  },
  modules: {
  },
  getters: {
    comics: state => {
      return state.comics || [];
    },
  }
})
